import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import tape from 'src/assets/images/resort/img_tsukutter_tape.svg';
import { AspectRatioImage } from 'src/components/shared/AspectRatioImage';
import { CharacterImage } from 'src/components/shared/CharacterImage';
import { HomeResident } from 'src/models/resort/HomeResident';

interface StructureFacilityInfoProps {
  resortImages: string[];
  npcs: HomeResident[];
}

export const StructureFacilityInfo: React.FC<StructureFacilityInfoProps> = ({
  resortImages,
  npcs
}) => {
  const { t } = useTranslation('resort');
  const constructionSubImage = resortImages[1];

  return (
    <div
      className={css`
        display: flex;
        align-items: flex-start;
        color: #756855;
        font-size: 14px;
        margin: 0 auto;
        .const-sub-image {
          flex-shrink: 0;
          width: 60%;
          border: 6px solid white;
          background: white;
          box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
          position: relative;
          margin-right: 12px;
          img {
            height: auto;
          }
          &::after {
            content: '';
            background-image: url(${tape});
            position: absolute;
            top: -14px;
            left: 50%;
            width: 20px;
            height: 21px;
            transform: translate(-50%, 0);
          }
        }
        .main-staff-label {
          font-size: 12px;
          color: #93844e;
          margin: 0 0 4px;
        }
        .cast {
          flex: 0 0 auto;
          display: inline-block;
          padding: 4px;
          background: #dfc973;
          border-left: 4px solid #cdb761;
          margin-right: 8px;
          &:last-child {
            margin-right: 0;
          }
        }
        .cast-image {
          width: 32px;
          height: 32px;
        }
      `}
    >
      <div className="const-sub-image">
        <AspectRatioImage
          src={constructionSubImage}
          width={960}
          height={540}
          ariaLabel={t('aria_construction_image_00')}
        />
      </div>

      {npcs.length > 0 ? (
        <div className="main-staff">
          <p id="main-staff-label" className="main-staff-label">
            {t('main_role')}
          </p>
          <ul className="casts" aria-labelledby="main-staff-label">
            {npcs.map((npc, index) => (
              <li className="cast" key={index}>
                <div className="cast-image">
                  <CharacterImage
                    src={npc.image}
                    isPlayer={false}
                    backgroundColor="#D5BB6F"
                    imageAriaLabel={npc.name}
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
